// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"96c495ae","498":"6bca8ccc","513":"563f0349","787":"909fdc84"}[chunkId] + ".chunk.js";
};